import { observable, action } from 'mobx';

export class HeaderStore {
  @observable activeKey = 'app';

  constructor(routing) {
    this.routing = routing;
  }

  @action
  init = () => {
    this.activeKey = 'app';
  }
  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach((key) => {
      this[key] = params[key];
    })
  }
}


// WEBPACK FOOTER //
// ./src/stores/order/HeaderStore.js